import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const BrandShopPage = lazy(
  () =>
    import('./BrandShopPage.eager').then(mod => ({default: mod.BrandShopPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
